/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Antifreezedefect2Inputs */



/**
* | output |
* | --- |
* | "Antifreeze fault" |
*
* @param {Ahu_History_Key_Antifreezedefect2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_antifreezedefect2 = /** @type {((inputs?: Ahu_History_Key_Antifreezedefect2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Antifreezedefect2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Antifreeze fault")
	return /** @type {LocalizedString} */ ("Défaut antigel")
});
export { ahu_history_key_antifreezedefect2 as "ahu_history_key_antiFreezeDefect" }